import React, { ChangeEvent, FocusEvent, KeyboardEventHandler } from 'react';
import { makeStyles, createStyles, TextField } from '@material-ui/core';

const useStyles = makeStyles(theme => createStyles({
	input: {
		...theme.typography.h1,
		color: theme.palette.grey[200],
		'&::placeholder': {
			color: theme.palette.grey[500],
			opacity: '1'
		}
	}
}));

interface EditBlockProps {
	placeholder: string | undefined;
	value: string;
	id?: string;
	onBlur?:  (event: FocusEvent<any>) => void;
	onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onKeyPress?: KeyboardEventHandler;
	onKeyUp?: KeyboardEventHandler;
	onKeyDown?: KeyboardEventHandler;
}

export const EditBlock = (props: EditBlockProps) => {
	const classes = useStyles();

	const inputProps = {
		disableUnderline: true,
		placeholder: props.placeholder,
		classes: { input: classes.input }
	};

	return (
		<TextField
			id={props.id}
			InputProps={inputProps}
			multiline={true}
			fullWidth={true}
			value={props.value}
			onBlur={props.onBlur}
			onKeyPress={props.onKeyPress}
			onKeyUp={props.onKeyUp}
			onKeyDown={props.onKeyDown}
			onChange={props.onChange} />
	);
};

export default EditBlock;
